module.exports = require('../../full/object/get-own-property-symbols');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/features/object/get-own-property-symbols.js
// module id = 1273
// module chunks = 25